<template>
  <div class="loginRecord">
    <h2 class="page-title">{{ mobile }}登陆记录</h2>

    <el-table :data="loginRecords" style="width: 100%; margin-top: 20px;"
      :header-cell-style="{ color: '#333', fontWeight: 'bold', fontsize: '14px' }">
      <el-table-column prop="deviceType" label="设备类型" min-width="40" />
      <el-table-column prop="browserType" label="浏览器类型" min-width="40" />
      <el-table-column prop="ipAddress" label="IP地址" min-width="40" />
      <el-table-column prop="updateTime" label="登录时间" min-width="80" >
        <template #default="scope">
            {{ formatDateTime(scope.row.updateTime) }}
          </template>
      </el-table-column>
      <el-table-column prop="userAgent" label="UserAgent" min-width="200" />
    </el-table>

    <div class="button-group">
      <el-button class="search_button" @click="clearRecords">一键清空登录记录</el-button>
    </div>
  </div>

</template>

<script setup>
import { ref, getCurrentInstance, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'
const route = useRoute();
const mobile = route.query.mobile;

const { proxy } = getCurrentInstance()

const loginRecords = ref([])

const fetchLoginRecords = async () => {
  try {
    const response = await proxy.$tools.request('/login/queryLoginRecord', {
      reqBody: { mobile: mobile }
    })

    if (response.data.rspHead.returnCode === '00000000') {
      loginRecords.value = response.data.rspBody.loginRecordList || []
    } else {
      ElMessage.error('获取记录失败：' + response.data.rspHead.returnMsg)
    }
  } catch (error) {
    ElMessage.error('系统异常：' + error.message)
  }
}

const clearRecords = async () => {
  proxy.$confirm('确认清除所有登录记录？', '警告', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    const response = await proxy.$tools.request('/login/clearLoginRecord', {
      reqBody: { mobile: mobile }
    })

    if (response.data.rspHead.returnCode === '00000000') {
      ElMessage.success('清除成功')
      fetchLoginRecords()
    } else {
      ElMessage.error('清除失败：' + response.data.rspHead.returnMsg)
    }
  }).catch(() => {
    // 取消操作的逻辑（可选）
    // 这里可以留空或者添加取消后的处理逻辑
  })
}

const formatDateTime = (dateString) => {
  const date = new Date(dateString)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

onMounted(() => {
  fetchLoginRecords()
})
</script>

<style scoped>
.loginRecord {
  padding: 20px;
}

.page-title {
  text-align: center;
  margin-bottom: 50px;
}

.button-group {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.search_button {
  background-color: #2b82cf;
  width: 300px;
  height: 40px;
  border: 1px solid #2b82cf;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}

.search_button:hover {
  background-color: #409eff;
  color: #fff;
}
</style>